export const isShowAlert = () => localStorage.getItem('alertBanner') == 'true';

export const isShowWarning = () => localStorage.getItem('warningAlert') === 'true';

export const isShowTunnelWarning = () => localStorage.getItem('tunnelAlert') === 'true';
